.note {
  display: flex;
  flex-flow: column nowrap;
  gap: 10px;
  padding: 10px 0 10px 15px;

  &[data-shall-animate-background='true'] {
    animation: fade-in-background 3s linear 1 forwards;
  }

  &__header {
    display: flex;
    flex-flow: column nowrap;
    gap: 10px;
  }

  &__content {
    font: use-font("400 16px/26px");

    & > * {
      margin-bottom: 15px;
      margin-top: 15px;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    b {
      font-weight: bold;
    }

    em,
    i {
      font-style: italic;
    }

    iframe,
    object {
      max-width: 100%;
    }

    h4 {
      font: use-font-secondary("700 20px/32px");
      overflow-wrap: break-word;
    }

    p,
    h5 {
      overflow-wrap: break-word;
    }

    u {
      text-decoration: underline;
      text-underline-offset: 3px;
    }

    a {
      color: var(--palette-foreground-primary);
      overflow-wrap: break-word;
      text-decoration: underline;
      text-underline-offset: 3px;
      transition: color .2s ease-out;

      &:hover {
        color: var(--palette-foreground-secondary);
      }
    }

    ul,
    ol {
      overflow-wrap: break-word;
      padding-left: 25px;

      & li {
        margin: 15px 0;

        &:first-child {
          margin-top: 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    ol {
      list-style: decimal outside;
    }

    ul {
      list-style: square outside;
    }

    & > blockquote {
      align-items: flex-start;
      color: var(--palette-foreground-primary);
      display: flex;
      font: use-font-secondary("italic 700 20px/26px");
      gap: 15px;
      margin: 30px 10px;
      position: relative;

      @include use-desktop-device {
        margin: 30px;
      }

      & > div {
        align-items: center;
        aspect-ratio: 1 / 1;
        background-color: var(--palette-accent-primary);
        border-radius: 50%;
        color: var(--palette-accent-primary-contra);
        display: flex;
        flex: none;
        font-size: 0;
        justify-content: center;
        line-height: 0;
        width: 30px;
      }
    }
  }
}

@keyframes fade-in-background {
  0% {
    background-color: var(--palette-background-primary);
  }

  10% {
    background-color: color-mix(in srgb, var(--palette-accent-primary) 30%, transparent);
  }

  90% {
    background-color: color-mix(in srgb, var(--palette-accent-primary) 30%, transparent);
  }

  100% {
    background-color: var(--palette-background-primary);
  }
}
